module.exports = __webpack_public_path__ + "img/04.ba13d6b3.jpg";